import React from "react"
import Tooltip from "design_system/core/components/tooltip"
import { monthFromInt, weekdayFromInt } from "@love-irish/i18n"

const DateHeader = ({
  className,
  currentDate = new Date(),
  as: Component = "p",
  // Inline displays text next to each other otherwise we show as a tooltip
  inline = true,
}) => {
  const weekday = weekdayFromInt(currentDate.getDay())
  const month = monthFromInt(currentDate.getMonth())

  if (inline) {
    return (
      <Component className={className}>
        <strong>
          {weekday.translation}, {currentDate.getDate()} {month.translation}
        </strong>{" "}
        &middot;{" "}
        <em>
          {weekday.text}, {currentDate.getDate()} {month.text}
        </em>
      </Component>
    )
  }

  return (
    <Component className={className}>
      <Tooltip
        title={`${weekday.text}, ${currentDate.getDate()} ${month.text}`}
      >
        <span className="text-definition font-normal!">
          {weekday.translation}, {currentDate.getDate()} {month.translation}
        </span>
      </Tooltip>
    </Component>
  )
}

export default DateHeader
